import { render, staticRenderFns } from "./BenefitIframe.vue?vue&type=template&id=6bc2aa3c&scoped=true&"
import script from "./BenefitIframe.vue?vue&type=script&lang=js&"
export * from "./BenefitIframe.vue?vue&type=script&lang=js&"
import style0 from "./BenefitIframe.vue?vue&type=style&index=0&id=6bc2aa3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2aa3c",
  null
  
)

export default component.exports